// src/pages/LiseYksVipPage.jsx
import React, { useState } from 'react';
import NavBar from '../components/NavBar';
import './LiseYksVipPage.css';
import headerImg from '../assets/vipkurs.jpg';
import { FaLightbulb } from 'react-icons/fa';
import ServiceSection from '../components/ServicesSection'; // ✅ EKLENDİ


import v1 from '../assets/vip1.jpeg';
import v2 from '../assets/vip2.jpeg';
import v3 from '../assets/vip3.jpeg';
import v4 from '../assets/vip4.jpeg';
import v5 from '../assets/vip5.jpeg';
import v6 from '../assets/vip6.jpeg';
import v7 from '../assets/vip7.jpeg';
import v8 from '../assets/vip8.jpeg';

export default function LiseYksVipPage() {
  const vipImages = [v1, v2, v3, v4, v5, v6, v7, v8];
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <NavBar />

      <section id="dikmen-kurs-lise-yks-vip-page" className="dikmen-kurs-lise-yks-vip-page">
        {/* Hero */}
        <div
          className="hero-bg"
          style={{ backgroundImage: `url(${headerImg})` }}
        >
          <div className="overlay" />
          <h1 className="hero-title">
          Dikmen’de Başarıya Giden Yol:<br /> 
          Yeldeğirmeni VIP Kurs • LGS - YKS Hazırlık
        </h1>

        </div>

        <div className="content">
          {/* 🧭 YKS + Haberler Satır Yapısı */}
          <div className="yks-news-row">
            {/* Sol: YKS Hazırlık */}
            <div className="yks-column">
              <h2>YKS Hazırlık</h2>
              <ul>
                <li>8-10 kişilik gruplarla, alanında uzman kadro ile TYT-AYT’ye hazırlık</li>
                <li>Öğrenciye özel seviyesine uygun özel yayın desteği</li>
                <li>Etüt salonları</li>
                <li>Eğitim eşlikçisi(koçluğu) ve PDR desteği</li>
                <li>Birebir etütler, öğrencinin ihtiyacına ve sınav sonuçlarına göre planlanır.</li>
                <li>Her öğrenciye eğitim eşlikçisi(koçluğu) belirlenir. Tüm eğitim faaliyetleri anlık şekilde programlanır ve velilere bildirilir.</li>
                <li>Her hafta yapılan farklı yayın deneme sınavları ile öğrencilerimiz Türkiye genelinde kendi sıralamalarını görür.</li>
              </ul>
            </div>

            {/* Sağ: Haberler Kutusu */}
            <div className="news-column">
              <h2>Haberler</h2>
              <div className="info-box" onClick={() => setShowModal(true)}>
                <div className="icon-wrapper">
                <div className="icon-wrapper">
                <img src={headerImg} alt="VIP Kurs" className="info-img" />
              </div>                </div>
                <div className="info-text">
                  <h3>Dikmen’de Kurs Seçerken Dikkat Edilmesi Gereken 5 Nokta</h3>
                  <p>Doğru kursu seçmek öğrencinin geleceğini şekillendiren en önemli adımlardan biridir. 👇</p>
                  <button className="info-btn">Detayları Gör</button>
                </div>
              </div>
            </div>
          </div>

          {/* Modal */}
          {showModal && (
            <div className="modal-overlay" onClick={() => setShowModal(false)}>
              <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
                <h2>Dikmen’de Kurs Seçerken Dikkat Edilmesi Gereken 5 Nokta</h2>
                <p>
                  Eğitim yolculuğunda doğru kursu seçmek, öğrencinin geleceğini şekillendiren en önemli adımlardan biridir.
                  Özellikle Dikmen ve çevresinde birçok kurs merkezi bulunuyor; ancak her kurumun eğitim anlayışı,
                  öğrenciye yaklaşımı ve sunduğu imkânlar farklıdır.
                </p>

                <h3>1. Bireysel Öğrenme Yaklaşımı</h3>
                <p>
                  Her öğrencinin öğrenme biçimi farklıdır. Bu nedenle kursun, öğrencinin bireysel öğrenme hızını
                  dikkate alan bir programa sahip olması büyük önem taşır.
                </p>

                <h3>2. Akademik Kadro ve Danışmanlık Desteği</h3>
                <p>
                  Alanında uzman öğretmenlerle çalışan bir kurs, öğrencinin hem konu hakimiyetini hem de özgüvenini artırır.
                  Ayrıca öğrencinin ders dışında da destek alabileceği bir rehberlik sistemi olmalıdır.
                </p>

                <h3>3. Etkin Öğrenme Ortamı</h3>
                <p>
                  Sadece sınıf ortamında değil, doğayla ve sanatla iç içe bir öğrenme ortamı sunan kurumlar,
                  öğrencinin kalıcı öğrenmesini sağlar.
                </p>

                <h3>4. Teknoloji ve Dijital Öğrenme Araçları</h3>
                <p>
                  Günümüz öğrencileri dijital dünyanın içinde büyüyor. Kursların dijital kaynaklar sunması önemlidir.
                </p>

                <h3>5. Kurumun Referansları ve Başarı Hikâyeleri</h3>
                <p>
                  Kurs seçiminde en güvenilir göstergelerden biri, mezunların başarı hikâyeleridir.
                  VIP Kurs, Dikmen bölgesinde birçok öğrencinin başarı yolculuğunda yanında olmuştur.
                </p>

                <h3>Sonuç Olarak</h3>
                <p>
                  Kurs seçimi sadece ders saatlerini belirlemek değil; çocuğunuzun geleceğine yön vermektir.
                  Yeldeğirmeni VIP Kurs, bireysel öğrenme temelli, ekolojik ve sanatla iç içe bir eğitim modeli sunar.
                </p>
              </div>
            </div>
          )}

          {/* Rehberlik Servisi */}
          <section className="guidance-section">
            <h2>Rehberlik servisi Yeldeğirmeni Eğitim Kurumlarında ne anlama gelir?</h2>
            <p>
              Sınav sürecinde öğrencilerimizi asla yalnız bırakmıyoruz. Haftalık birebir görüşmelerimizde
              öğrencilerimizin ders programlarını hazırlayarak ve haftalık olarak güncelleyerek fiziksel
              hazırlıklarına katkı sunarken aynı zamanda mental olarak da her zaman yanlarında oluyoruz.
              Her öğrencimiz kişisel mentörleri ile bu sürece en iyi şekilde motive olup hazırlanırken,
              aynı zamanda aile, öğrenci, rehberlik üçgenimiz ile velilerimizin de her zorlu koşulda
              yanında oluyoruz. Sene boyunca yapacağımız seminerler ile sınav stresi, başarı kaygısı,
              zaman yönetimi konusunda öğrencilerimizi bilgilendirmeyi amaçlıyoruz. Sınav sonrası tercih
              süreçlerinde en doğru tercihi yapabilmesi için öğrencilerimizin yanında yürümeyi bırakmıyoruz.
            </p>
            <h3>🎯 Yeldeğirmeni Eğitim Kurumları Rehberlik Servisi</h3>
            <ul className="guidance-list">
              <li>📌 Haftalık birebir görüşmeler</li>
              <li>📌 Kişiye özel ders programları</li>
              <li>📌 Mental destek & motivasyon</li>
              <li>📌 Veli–öğrenci–rehberlik iş birliği</li>
              <li>📌 Sınav stresi, kaygı yönetimi, zaman planlaması seminerleri</li>
              <li>📌 Tercih döneminde tam destek!</li>
            </ul>
            <p>
              Her öğrencimize özel kişisel mentörlük ile bu zorlu süreci birlikte ve güçlü bir şekilde aşıyoruz.
            </p>
            <div className="guidance-spot">
              Yanınızda bir ekip var. Rehberlik bizim işimiz. Başarı sizinle !
            </div>
            
          </section>

          {/* LGS Hazırlık Kursu Tanıtım Yazısı */}
          <section className="promo-section">
            <h2>LGS Hazırlık Kursu – Geleceğe Güvenle Hazırlanın!</h2>
            <p>
              Liselere Geçiş Sistemi (LGS), öğrencilerin akademik geleceğini şekillendiren en önemli
              adımlardan biridir. Biz de bu bilinçle, öğrencilerimizin potansiyelini en üst düzeye
              çıkarmak ve onları başarıya ulaştırmak için özel olarak hazırlanmış LGS Hazırlık
              Kursumuzu sunuyoruz.
            </p>
            <p>
               <strong>Nitelikli Eğitim Kadrosu</strong><br/>
              Alanında uzman öğretmenlerimiz, MEB müfredatına uygun ve güncel sınav sistemine entegre
              edilmiş programlarla öğrencilerimizi donanımlı hale getirir.
            </p>
            <p>
               <strong>Düzenli Deneme Sınavları ve Analizler</strong><br/>
              Her hafta yapılan deneme sınavlarıyla öğrencilerimizin seviyesini takip ediyor, ayrıntılı
              analizlerle eksiklerini tespit edip bireysel destek sağlıyoruz.
            </p>
            <p>
               <strong>Kapsamlı Kaynak ve Rehberlik Desteği</strong><br/>
              Öğrencilerimize, seviyelerine uygun kaliteli yayınlar sunuyor; profesyonel PDR desteğiyle
              sınav sürecinde hem öğrenciye hem de veliye rehberlik ediyoruz.
            </p>
            <p>
               <strong>Planlı ve Disiplinli Eğitim Ortamı</strong><br/>
              Etüt programları, soru çözüm saatleri ve birebir desteklerle öğrencilerimizin zamanı
              verimli kullanmalarını sağlıyoruz.
            </p>
            <p>
               <strong>Hedef: Nitelikli Liseler</strong><br/>
              Amacımız sadece sınavı kazandırmak değil, öğrencilerimizi istedikleri nitelikli liselere
              yerleştirerek hayallerine bir adım daha yaklaştırmak.
            </p>
            <p>
              Geleceğinize bugünden yatırım yapın!<br/>
              Siz de LGS’ye hazırlık sürecinde doğru adımlarla ilerlemek istiyorsanız, biz buradayız.
              Başarıya giden yolda size eşlik etmekten mutluluk duyarız.<br/>
               Detaylı bilgi ve kayıt için bizimle iletişime geçin!
            </p>
          </section>

          {/* Kafe Kütüphane Tanıtım Yazısı */}
          <section className="promo-section">
            <h2>Sadece Üyelerine Açık, Sessizliğin ve Başarının Adresi: KAFE KÜTÜPHANE</h2>
            <p>
              Sınava hazırlık süreci, dikkat ve odaklanma gerektirir. Gürültüden uzak, motive edici ve
              özel bir alan herkesin hakkı. Kafe Kütüphane, YKS ve LGS’ye hazırlanan öğrenciler için sadece
              üyelikle giriş yapılan, güvenli, konforlu ve disiplinli bir çalışma ortamıdır.
            </p>
            <ul>
              <li>✔️ Sadece sınava hazırlanan öğrencilere özel, sessiz ve verimli bir ortam</li>
              <li>✔️ Saat 22.00’ye kadar ders çalışma alanı</li>
              <li>✔️ Kaynak desteği, deneme sınavları ve bireysel takip sistemi</li>
              <li>✔️ Sıcak-soğuk içecek ve atıştırmalık seçenekleriyle kafe konforu</li>
              <li>✔️ Rehberlik (PDR) desteğiyle planlı ve sürdürülebilir çalışma sistemi</li>
              <li>✔️ Telefon ve dikkat dağıtan unsurlardan uzak, sınav modunda bir düzen</li>
            </ul>
            <p>
              Üyelerimiz, hem bireysel çalışma hem de deneme ve konu tekrarlarına uygun şekilde
              planlanan bir eğitim atmosferinde sınav sürecine hazırlanır.<br/>
               Sessizliğiyle huzur, disipliniyle başarı, ortamıyla ilham veren bir yer...
            </p>
          </section>

          {/* Ara Gruplar */}
          <h3>Ara Gruplar</h3>
          <p>Sınavlara erken hazırlıkta elde edilecek avantajlar:</p>
          <ul>
            <li>Her derse yeterince zaman ayırmanın verdiği güven.</li>
            <li>Sınavlarda gelebilecek konu ve soru türleri hakkında farkındalık.</li>
            <li>Erken hazırlıkla sınav öncesi ve sınav anındaki panik en aza inecektir.</li>
            <li>Konular daha geniş zamana yayılacak, kalıcı öğrenme sağlanacaktır.</li>
            <li>Okul sınavlarına yapılan hazırlıklarla okul başarı puanı artacaktır.</li>
          </ul>

          {/* ÖZEL DERSLER */}
          <h3>ÖZEL DERSLER</h3>
          <p>
            Her öğrencinin bireysel öğrenme durumu farklıdır. Bu doğrultuda Yeldeğirmeni VIP Kurs olarak,
            öğrencilerin branş ihtiyaçları belirlenerek bireysel ya da küçük gruplar halinde özel ders
            imkânı sağlanmaktadır.
          </p>

          {/* SEMİNERLER */}
          <h3>SEMİNERLER</h3>
          <p>
            Eğitim süreci yalnızca öğrencilerimizin çabasıyla değil, aile desteğiyle de güçlenir. Bu
            anlayışla veli‑öğrenci seminerleri düzenliyoruz. Bu seminerlerde:
          </p>
          <ul>
            <li>YKS ve LGS sınav sistemleri hakkında bilgiler</li>
            <li>Öğrencilerin akademik ve psikolojik gelişim süreçleri</li>
            <li>Etkili ve verimli ders çalışma teknikleri</li>
            <li>Aile içi iletişimin başarı üzerindeki rolü</li>
          </ul>

          {/* DENEME KULÜBÜ */}
          <h3>DENEME KULÜBÜ</h3>
          <p>
            Deneme Kulübü, her hafta farklı yayınevlerine ait deneme sınavlarının uygulanarak öğrencilerin
            seviyelerinin Türkiye geneli sıralamalarla ölçülebildiği özel bir programdır.
          </p>
          <ul>
            <li>Her hafta farklı bir yayın ile Türkiye geneli başarı sıralamaları ölçülür.</li>
            <li>Deneme Kulübü’ne katılan tüm öğrencilere YKS ve LGS Gerçek Merkez Prova Sınavları ücretsiz sunulur.</li>
          </ul>

          {/* VIP Tablo */}
          <div className="table-container">
            <table className="vip-table">
              <thead>
                <tr>
                  <th>Kurs Kategorisi</th>
                  <th>Açıklama</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>İlkokul Etüt</td>
                  <td>
                    1,2,3,4. sınıf öğrencilerine birebir ödev takibi;<br/>
                    Sosyal etkinlikler;<br/>
                    Hafta içi 5 gün
                  </td>
                </tr>
                <tr>
                  <td>5-6-7. Sınıflar</td>
                  <td>
                    Okula destek kursları;<br/>
                    Yazılılara hazırlık;<br/>
                    Sosyal etkinlikler;<br/>
                    Hafta içi 2 gün, hafta sonu 1 gün
                  </td>
                </tr>
                <tr>
                  <td>LGS Hazırlık</td>
                  <td>
                    8 kişilik sınıflar;<br/>
                    Bireysel etüt;<br/>
                    PDR desteği;<br/>
                    Başarı takibi;<br/>
                    Veli bilgilendirme;<br/>
                    Haftada 5 gün ders + deneme
                  </td>
                </tr>
                <tr>
                  <td>9-10-11. Sınıflar</td>
                  <td>
                    Okula destek kursları;<br/>
                    Yazılı hazırlık;<br/>
                    TYT hazırlık;<br/>
                    Haftada 4 gün eğitim;<br/>
                    Etkin rehberlik
                  </td>
                </tr>
                <tr>
                  <td>12 ve Mezun YKS</td>
                  <td>
                    TYT‑AYT hazırlık;<br/>
                    8-10 kişilik sınıflar;<br/>
                    Bireysel etüt + soru çözümü;<br/>
                    Veli bilgilendirme;<br/>
                    Haftada 5 gün eğitim + deneme;<br/>
                    Haftalık 24 saat ders
                  </td>
                </tr>
                <tr>
                  <td>Özel Dersler</td>
                  <td>Birebir ve grup dersleri</td>
                </tr>
                <tr>
                  <td>Cafe Kütüphane</td>
                  <td>22:00’ye kadar açık kütüphane + kafe</td>
                </tr>
                <tr>
                  <td>Deneme Kulübü</td>
                  <td>
                    Her hafta farklı bir yayın;<br/>
                    Türkiye geneli denemeler;<br/>
                    Prova sınavları
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ServiceSection />


        {/* VIP Görseller */}
        <div className="vip-images-wrapper">
          <div className="vip-images-grid">
            {vipImages.map((src, idx) => (
              <img key={idx} src={src} alt={`VIP Kurs ${idx + 1}`} />
            ))}
          </div>
        </div>

      </section>
    </>
  );
}
